import { twMerge } from 'tailwind-merge';
import Spinner, { type SpinnerProps } from '@/components/Spinner';
import { AlertIcon, CheckIcon } from '@/icons';
import type { CreationStepStatus } from '../../types';
import { CREATION_STEP_STATUS } from '../../constants';
import { classes } from './utils';

const { PENDING, IN_PROGRESS, FAILED } = CREATION_STEP_STATUS;

export type StepStatusProps = {
  status: CreationStepStatus;
  onRetry?: () => void;
};

export default function StepStatus({ status, onRetry }: StepStatusProps) {
  const spinnerProps: SpinnerProps = { size: 24 };
  if (status === PENDING) {
    return (
      <div className={classes.wrapper}>
        <Spinner progress={0} {...spinnerProps} />
      </div>
    );
  } else if (status === IN_PROGRESS) {
    return (
      <div className={classes.wrapper}>
        <Spinner {...spinnerProps} />
      </div>
    );
  } else if (status === FAILED) {
    return (
      <button
        disabled={!onRetry}
        className={twMerge(classes.wrapper, classes.failed)}
        type="button"
        aria-label="Retry"
        onClick={onRetry}>
        <AlertIcon />
      </button>
    );
  } else {
    return (
      <div className={twMerge(classes.wrapper, classes.done)}>
        <CheckIcon />
      </div>
    );
  }
}
